module.exports = __webpack_public_path__ + "static/media/logo-AppMosphera-r.2e35d941.png";